				import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BlobResponse } from '../../Models/OtherClasses';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class CourseFeedbackService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('CourseFeedback');
	}
	
	loadAll(searchObj: ePM.Logic.PersonSearchVM): Observable<ePM.Logic.CourseFeedback[]> {
		return this.myBaseService.post(searchObj, this.url + "/All?export=false");
	}
	loadAllExport(searchObj: ePM.Logic.PersonSearchVM): Observable<BlobResponse> {
		return this.myBaseService.returnBlob(searchObj, this.url + "/All?export=true");
	}
	save(tempItem: ECI.Basic.ObjectBase) : Observable<ePM.Logic.CourseFeedback> {
		return this.myBaseService.save(tempItem, this.url);
	}
	
	getEdit(id: System.Guid): Observable<ePM.Logic.CourseFeedback> {
		return this.myBaseService.getEdit(id, this.url);
	}
}
				